export function Spinner({ className = '' }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="loading"
      className={`inline-block h-5 w-5 animate-spin rounded-full border-2 border-conduril/25 border-t-conduril ${className}`}
    />
  );
}
